export default "/images/vendor/flag-icon-css/flags/4x3/vi.svg?2394a011069c69dcda825d1bcda172d5";